import React, { useMemo } from "react";

// Lightweight CSS snow. Fewer flakes on small screens; disabled via prefers-reduced-motion in CSS.
export default function SnowLayer({ count = 40, className = "" }) {
  const flakes = useMemo(() => {
    const isSmall = typeof window !== "undefined" && window.innerWidth < 640;
    const n = isSmall ? Math.round(count * 0.5) : count;
    return Array.from({ length: n }).map((_, i) => {
      const size = 2 + Math.random() * 5;
      return {
        id: i,
        left: Math.random() * 100,
        size,
        duration: 8 + Math.random() * 12,
        delay: -Math.random() * 15,
        opacity: 0.3 + Math.random() * 0.6,
      };
    });
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {flakes.map((f) => (
        <span
          key={f.id}
          className="snowflake"
          style={{
            left: `${f.left}%`,
            width: `${f.size}px`,
            height: `${f.size}px`,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            filter: "blur(0.4px)",
          }}
        />
      ))}
    </div>
  );
}
